export default __webpack_public_path__ + "static/media/NIAS0560.34I-40204_-23871_0.f4e4c7ac.jpg";